import axios from "axios";
const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;
// Auth via httpOnly cookie only (no tokens in localStorage — XSS-safe)
export const api = axios.create({ baseURL: API, withCredentials: true });
export const rupee = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");
